import React, { useRef, useState, useEffect } from 'react';
import '../styles/VideoSection.css';

const VideoSection = () => {
  const videoRef = useRef(null);
  // const [isPlaying, setIsPlaying] = useState(false);
  // const [isFullScreen, setIsFullScreen] = useState(false);
  // const [showThumbnail, setShowThumbnail] = useState(true);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showThumbnail, setShowThumbnail] = useState(true);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);


  const images = [
    "/thumbnl.jpg",
     "/smartclass.jpg",
    "/home1.jpg",
    "/home2.jpg",
    "/home3.jpg",
    "/home4.jpg",
    "/home6.jpg",
    "/home7.jpg",
    // Add more image paths as needed
  ];

  const togglePlay = () => {
    if (videoRef.current.paused) {
      videoRef.current.play();
      setIsPlaying(true);
      setShowThumbnail(false); // Hide thumbnail when video starts
    } else {
      videoRef.current.pause();
      setIsPlaying(false);
    }
  };

  const openFullVideo = () => {
    setIsFullScreen(true);
  };

  const closeFullVideo = () => {
    setIsFullScreen(false);
  };



  useEffect(() => {
  if (!showThumbnail) return; // Stop slideshow once video starts

  const interval = setInterval(() => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  }, 3000); // Change image every 3 seconds

  return () => clearInterval(interval); // Cleanup on unmount
}, [showThumbnail]);




  return (
    <section className="video-section">
      {/* Thumbnail - Only visible before video plays */}
      {showThumbnail && (
        <div className="thumbnail" onClick={togglePlay}>
          <img src={images[currentImageIndex]} alt={`Thumbnail ${currentImageIndex + 1}`} />
          <button className="play-button">
            ▶
          </button>
        </div>
      )}

      {/* Video Player */}
      <video ref={videoRef} loop muted className={showThumbnail ? "hidden" : ""}>
        <source src="/mayalawasF.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className="overlay">
        <span className="overlay-h">Shri Kheteshwar Gurukul</span>
        <button className="full-video-btn" onClick={openFullVideo}>
          Watch Full Video
        </button>
      </div>

      {/* Play/Pause Button */}
      <button className="play-pause-btn" onClick={togglePlay}>
        {isPlaying ? (
          <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
          </svg>
        ) : (
          <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M8 5v14l11-7z" />
          </svg>
        )}
      </button>

      {/* Full Video Overlay */}
      {isFullScreen && (
        <div className="full-video-overlay">
          <div className="full-video-container">
            <video autoPlay loop muted controls>
              <source src="/mayalawasF.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <button className="close-full-video-btn" onClick={closeFullVideo}>
              &times;
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default VideoSection;
